import styled from 'styled-components';

export const ButtonBlue = styled.button`
  max-width: 1200px;
  margin: 0 auto;
`;


export const ModalOverlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 99999999999;
  padding: 20px;
  overflow-y: auto;

  @media (max-width: 480px) {
    align-items: flex-start;
    padding: 12px;
  }
`;


export const ModalOverlayProduct = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  overflow-y: auto;
`;

export const ModalContent = styled.div`
  background: white;
  border-radius: 8px;
  padding: 24px;
  width: 400px;
  max-width: 100%;
  max-height: calc(100dvh - 40px);
  overflow-y: auto;

  @media (max-width: 480px) {
    padding: 18px 14px;
    max-height: calc(100dvh - 24px);
  }
`;
export const ModalContent2 = styled.div`
  background: white;
  border-radius: 8px;
  // width: 400px;
`;
export const ModalContentProduct = styled.div`
  background: white;
  border-radius: 8px;
  padding: 24px;
  width: 60%;
  max-height: calc(100dvh - 40px);
  overflow-y: auto;

  @media (max-width: 900px) {
    width: 100%;
  }
`;

export const HeadersModal = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom:20px;
    cursor:pointer;
`

export const Field = styled.div`
  margin-bottom: 16px;
`;

export const OptionsList = styled.ul`
  position: absolute;
  width: 100%;
  max-height: 150px;
  overflow-y: auto;
  margin: 0;
  padding: 0;
  list-style: none;
  background: #fff;
  border: 1px solid #ccc;
  border-radius: 8px;
  z-index: 10;
`;

export const Option = styled.li`
  padding: 8px 12px;
  cursor: pointer;

  &:hover {
    background: #f2f2f2;
  }
`;


export const Label = styled.label`
  display: block;
  font-weight: 500;
  margin-bottom: 6px;
`;
export const Sup = styled.sup`
  color:red;
  font-size:14px,
  position:absolute
`;

export const 
Input = styled.input`
  width: 100%;
  padding: 8px 12px;
  border: 1px solid #ddd;
  border-radius: 6px;
`;
export const TextArea = styled.textarea`
  width: 100%;
  padding: 8px 12px;
  border: 1px solid #ddd;
  border-radius: 6px;
`;

export const CheckboxLabel = styled.label`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 6px;
`;

export const ButtonRow = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;

  @media (max-width: 480px) {
    flex-direction: column-reverse;

    button {
      width: 100%;
    }
  }
`;

export const Button = styled.button`
  padding: 8px 14px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;

  ${({ variant }) =>
    variant === "primary"
      ? `
        background: #3b82f6;
        color: white;
        &:hover { background: #2563eb; }
      `
      : `
        background: #f3f4f6;
        &:hover { background: #e5e7eb; }
      `}
`;


export const DropdownWrapper = styled.div`
  width: 100%;
  position: relative;
`;

export const SelectBox = styled.div`
  width: 100%;
  padding: 10px;
  border-radius: 8px;
  border: 1px solid #ccc;
  background-color: #fff;
  font-size: 14px;
  cursor: pointer;
`;


export const SelectedItems = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 6px;
`;


export const Item = styled.option`
  padding: 10px;
  font-size: 14px;
`;
export const Dropdown = styled.select`
  width: 100%;
  padding: 10px;
  border-radius: 8px;
  border: 1px solid #ccc;
  background-color: #fff;
  font-size: 14px;
  cursor: pointer;

  &:focus {
    outline: none;
    border-color: #007bff;
  }
`;

export const AddButton = styled.button`
  background: #30D5C8;
  color: white;
  border: none;
  padding: 12px 20px;
  border-radius: 8px;
  width:100%;
  text-align:center;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s ease;
  gap: 8px;

  &:hover {
    background: #572230;
  }
`;
export const AddVariantBtn = styled.button`
  background: #30D5C8;
  color: white;
  border: none;
  padding: 10px 0px;
  border-radius: 8px;
  width:80px;
  text-align:center;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s ease;
  gap: 8px;

  &:hover {
    background: #26a79d;
  }
`;

export const ProductsGridTwo = styled.div`
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const ProductCardTwo = styled.div`
  background: white;
  border-radius: 12px;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);
  border: 1px solid #e2e8f0;
  overflow: hidden;
  transition: transform 0.2s ease, box-shadow 0.2s ease;

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
  }
`;


export const ProductImageTwo = styled.div`
  height: 200px;
  background: linear-gradient(135deg, #f3f4f6 0%, #e5e7eb 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 64px;
  border-bottom: 1px solid #e2e8f0;
`;

export const ProductInfoTwo = styled.div`
  padding: 20px;
`;

export const ProductNameTwo = styled.h3`
  font-size: 18px;
  font-weight: 600;
  color: #1e293b;
  margin-bottom: 8px;
`;


export const ProductsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const ListItem = styled.div`
  display: flex;
  align-items: center;
  padding: 12px;
  border: 1px solid #ddd;
  border-radius: 8px;
  background: #fff;
  cursor:pointer;
`;

export const ListItemOne = styled.div`
  display: flex;
  align-items: center;
  padding: 12px;
  border: 1px solid #ddd;
  border-radius: 8px;
  background: #fff;
  cursor: pointer;
  transition: background 0.3s ease, border-color 0.3s ease;

  &:hover {
    background: #f0f4ff; /* light blue hover */
    border-color: #a3bffa;
  }
`;

export const ListImage = styled.div`
  width: 60px;
  height: 60px;
  margin-right: 16px;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 6px;
  }
`;

export const ListInfo = styled.div`
  flex: 1;
`;

export const ListName = styled.div`
  font-weight: 600;
`;

export const ListCategory = styled.div`
  font-size: 14px;
  color: #666;
`;

export const ListActions = styled.div`
  display: flex;
  gap: 8px;
`;

export const ListActionButton = styled.button`
  border: none;
  background: none;
  cursor: pointer;
  font-size: 18px;
`;

export const TableRowProduct = styled.div`
  display: grid;
   grid-template-columns: ${({ cols }) => `repeat(${cols}, 2fr)`};
  gap: 16px;
  padding: 16px 20px;
  background: #f8fafc;
  // border-bottom: 1px solid #e2e8f0;
  font-weight: 600;
  font-size: 14px;
  color: #64748b;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 8px;
    padding: 14px;
  }
`;



export const TabsWrapper = styled.div`
  width: 100%;
  // max-width: 500px;
  // margin: 50px auto;
  font-family: "Poppins", sans-serif;
  background: #f9fafb;
  border-radius: 12px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.08);
  overflow: hidden;
`;

// Tab header container
export const TabHeader = styled.div`
  display: flex;
  background: #f0f2f5;
  overflow-x: auto;
`;

// Individual tab button
export const TabButton = styled.button`
  flex: 1;
  padding: 14px 18px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  border: none;
  outline: none;
  background: ${(props) => (props.active ? "#30D5C8" : "transparent")};
  color: ${(props) => (props.active ? "#fff" : "#555")};
  transition: all 0.3s ease;
  min-width: max-content;

  &:hover {
    background: ${(props) => (props.active ? "#30D5C8" : "#e4e6eb")};
  }
`;
